/**
 * Alto Brilho logo component.
 * variant="mark" — shows just the gold coin mark (square, dark background)
 * variant="full" — shows the entire logo (mark + "ALTO BRILHO" text)
 */
export function Logo({ variant = "mark", className = "", size = 40 }) {
    if (variant === "full") {
        return (
            <img
                src="/logo.webp"
                alt="Alto Brilho"
                className={`select-none ${className}`}
                style={{ height: size * 1.1, width: "auto" }}
                draggable={false}
            />
        );
    }
    return (
        <div
            className={`overflow-hidden bg-black rounded-md ring-1 ring-[#C9A961]/30 ${className}`}
            style={{ width: size, height: size }}
            aria-label="Alto Brilho"
        >
            <img
                src="/logo.webp"
                alt=""
                aria-hidden="true"
                className="w-full h-auto select-none"
                draggable={false}
                style={{
                    transform: "scale(1.42) translateY(-11%)",
                    transformOrigin: "center",
                }}
            />
        </div>
    );
}

export default Logo;
